import { render, staticRenderFns } from "./SgExtAttrWrap.vue?vue&type=template&id=dd724b5e&scoped=true&"
import script from "./SgExtAttrWrap.vue?vue&type=script&lang=js&"
export * from "./SgExtAttrWrap.vue?vue&type=script&lang=js&"
import style0 from "./SgExtAttrWrap.vue?vue&type=style&index=0&id=dd724b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd724b5e",
  null
  
)

export default component.exports